<template>
  <div class="addSaleFee">
    <!-- 添加买家 -->
    <md-popup v-model="show" :mask-closable="false">
      <md-popup-title-bar title="新增销售附加费" :only-close="true" @cancel="cancelPop()"></md-popup-title-bar>
      <div class="pop_content">
          <md-field>
            <md-field-item solid title="费用类型">
              <md-radio-group v-model="subData.type">
                <md-radio-box v-for="(item,index) in pack_list" :key="index" :name="item.value" >{{item.name}}</md-radio-box>
              </md-radio-group>
            </md-field-item>
            <md-input-item title="费用名称" clearable type="text" v-model="subData.name" placeholder="请输入费用名称"></md-input-item>
            <md-input-item v-if="subData.type == 1" title="数量" clearable type="number" v-model="subData.num" placeholder="请输入数量">
              <template slot="right">
                个
              </template>
            </md-input-item>
            <md-input-item v-if="subData.type == 1" title="单价" clearable type="number" v-model="subData.price" placeholder="请输入单价">
              <template slot="right">
                元/个
              </template>
            </md-input-item>
            <md-input-item v-if="subData.type == 2" title="金额" clearable type="number" v-model="subData.price" placeholder="请输入金额">
              <template slot="right">
                元
              </template>
            </md-input-item>
          </md-field>
          <div class="pop_btns">
            <md-button type="warning" plain size="small" inline @click="cancelPop()">取消</md-button>
            <md-button type="primary" size="small" inline @click="submitData()">保存</md-button>
          </div>
      </div>
    </md-popup>

  </div>
</template>

<script>
import { saleFee_update } from "@/api/work/stock";
import { isNumFloat,isPosFloat } from "@/utils/validate";
export default {
  name: 'addSaleFee',
  data(){
    return {
      show:false,
      loading:true,
      pack_list: [
        { value: '1', name: "按量收费" ,desc:'按数量收费，如押箱费'},
        { value: '2', name: "按单收费" ,desc:'按订单收费，每个订单收取一笔'}
      ],
      subData:{
        id:'',
        name:'',
        type:'1',
        bale:'4',
        num_unit:1,
        bale_num:0,
        num:'',
        weight:0,
        price:'',
      },
    }
  },
  created(){
    
  },
  mounted(){
    
  },
  methods:{
    // 显示弹窗
    showPop(item){
      if(item){
        this.subData = {
          id:item.id,
          name:item.name,
          type:item.type + '',
          bale:'4',
          num_unit:'',
          bale_num:'',
          num:Number(item.num) ,
          weight:'',
          price:Number(item.price),
        }
      }
      this.show = true
    },
    // 取消弹窗
    cancelPop(){
      this.show = false
      this.resetData()
      this.$emit("cancel")
    },
    // 取消弹窗
    finishPop(){
      this.show = false
      this.resetData()
      this.$emit("finish")
    },
    // 重置数据
    resetData(){
      this.subData = {
        id:'',
        name:'',
        type:'1',
        bale:'4',
        num_unit:1,
        bale_num:0,
        num:'',
        weight:0,
        price:'',
      }
    },
    // 提交数据
    submitData(type){
      if(!this.subData.name){this.$toast.info("请输入费用名称！"); return false }
      if(this.subData.type == 1 && (!isPosFloat(this.subData.num) || this.subData.num == 0) ){this.$toast.info("请输入费用数量！"); return false }
      if(!isNumFloat(this.subData.price) && (this.subData.type == 1)){this.$toast.info("请输入货品单价！"); return false }
      if(!isNumFloat(this.subData.price) && (this.subData.type == 2)){this.$toast.info("请输入货品金额！"); return false }
      if(!this.loading){ return false }
      this.loading = false
      if(this.subData.type == 2 ) {this.subData.num = 1}
      saleFee_update(this.subData).then(res=>{
        this.loading = true
        this.$toast.succeed(res.message)
        this.finishPop()
      }).catch(err=>{
        this.loading = true
      })
    },
  }
}
</script>

<style lang="less" scoped>
.addSaleFee{
  position: relative;
  // 添加买家模块
  .pop_content {
    width: 5rem;
    // height: 6rem;
    background-color: #fff;
    border-radius:0 0 0.08rem 0.08rem;
    overflow: hidden;
    padding:0.1rem 0.2rem 0;
    position: relative;
    .pop_btns{
      padding: 0.35rem 1rem 0.2rem;
      display: flex;
      align-items: center;
      justify-content: space-around;
    }
  }
}
</style>